module.exports = __webpack_public_path__ + "static/media/download-black.806ca9b8.svg";